module.exports = __webpack_public_path__ + "static/media/03-quiz.d71a060a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-courses-work/03-quiz.jpg
// module id = 372
// module chunks = 0